import React from 'react';
var AsyncExternalUserOption = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/user-picker/external-user-option" */'./main').then(function (module) {
    return {
      default: module.ExternalUserOption
    };
  });
});
export default AsyncExternalUserOption;